import { action, observable, runInAction } from "mobx";
import * as moment from "moment";
import {
  DashboardGraph,
  IEmpresa,
  IEmpresaErrosSefaz,
  IEmpresaNotaDivergente,
  IEmpresaRetroativa,
  IResultadoItem,
  IResultadoItemProdutos,
  newDashboardGraph,
  newEmpresa,
  newIContratoUser,
  newIUsuario,
} from "../model";
import { PerfilStore } from "./perfil/PerfilStore";
import { toast } from "react-toastify";
import history from "../components/others/redirect";
import { api } from "../api";
import { SitfisStore } from "./sitfis/SitifisStore";

export interface AppLocation {
  area: string;
  action?: string;
  id?: any;
}

export class _AppStore {
  obs: DashboardGraph = observable(newDashboardGraph())

  obs1 = observable({

    selectedEmpresa: newEmpresa() as IEmpresa,
    selectedPeriod: [moment().startOf("month").toDate(), moment().endOf("month").toDate()] as any,

    usuario: newIUsuario(),
    location: {} as AppLocation,
    empresasRetroativas: [] as IEmpresaRetroativa[],
    empresaNotaDivergente: [] as IEmpresaNotaDivergente[],
    empresaErrosSefaz: [] as IEmpresaErrosSefaz[],
    contestarItem: null as IResultadoItem,
    contestarItemProduto: null as IResultadoItemProdutos,
    title: "",
    timer: [] as any,
    result_ok: false,
    contaId: "" as string,
    stats: {
      empresa_count: 0,
      cert_count: 0,
      cert_venc: 0,
      nota_count: 0,
      empresa_plano_count: 0,
      empresa_count_inativas: 0,
      empresas_sem_certificado: 0,
      empresa_count_ativas: 0
    },
    versionUpdates: "1.0.15",
    dados_contrato: newIContratoUser(),
    logged: false as boolean,
    releases_length: 0 as number,
    releases: [] as any,
    instavel: false
  })

  @action
  setTitle(title: string) {
    this.obs1.title = title;
  }

  setSelectedEmpresa(empresa: IEmpresa) {
    this.obs1.selectedEmpresa = empresa;
  }

  setSelectedPeriod(period: any) {
    this.obs1.selectedPeriod = period;
  }

  setSelectedPeriodAndEmpresa(period: any, empresa: IEmpresa) {
    this.obs1.selectedEmpresa = empresa;
    this.obs1.selectedPeriod = period;
  }

  @action
  setContestarItem(item: IResultadoItem) {
    this.obs1.contestarItem = item;
  }

  @action
  setContestarProduto(item: IResultadoItemProdutos) {
    this.obs1.contestarItemProduto = item;
  }

  @action
  setLocation(path: string) {
    history.push(path);
  }

  @action
  async loadStats() {
    try {
      let resp = await api.get("/api/notas/stats");
      this.obs1.stats = resp.data;
    } catch (ex) {
      toast.error("Erro ao carregar Notas Stats, tente novamente mais tarde.", {});
    } finally {
    }
  }

  @action
  private setLocationFromPath(path: string) {
    let parts = path.split("/");
    let loc = {
      area: parts[1],
      action: parts[2],
      id: parts[3] ? String(parts[3]) : null,
    };
    this.obs1.location = loc;
  }

  @action
  public async loadUsuario() {
    try {
      let resp = await api.get("/api/me");

      this.obs1.dados_contrato = resp.data.usuario.conta
      this.obs1.usuario = resp.data.usuario;
      this.obs1.contaId = this.obs1.usuario.conta_id;

      PerfilStore.obs.metodo_pagamento = (resp.data.usuario.conta.forma_pagamento || [])
      PerfilStore.obs.expires_at = resp.data.usuario.conta.expires_at ? new Date(resp.data.usuario.conta.expires_at) : null;

    } catch (ex) { }
  }

  @action
  public async loadEmpresasRetroativas(): Promise<void> {
    try {
      let resp = await api.get("/api/empresas-retroativas");

      runInAction(() => {
        if (resp.data.length > 0) {
          this.obs1.empresasRetroativas = resp.data;
        } else {
          this.obs1.empresasRetroativas = [];
        }
      });
    } catch (ex) {
      toast.error("Erro ao carregar Empresas Retroativas, tente novamente mais tarde.", {});
    }
  }

  @action
  public async loadEmpresasNotaDivergente(): Promise<void> {
    try {
      let resp = await api.get("/api/empresas-nota-divergente");

      runInAction(() => {
        if (Array.isArray(resp.data)) {
          this.obs1.empresaNotaDivergente = resp.data;
        } else {
          this.obs1.empresaNotaDivergente = [];
        }
      });
    } catch (ex) {
      toast.error("Erro ao carregar Empresas notas Divergentes, tente novamente mais tarde.", {});
    }
  }

  @action
  public async loadErrosSefaz(): Promise<void> {
    try {
      let resp = await api.get("/api/empresas-erros-sefaz");

      runInAction(() => {
        if (Array.isArray(resp.data)) {
          this.obs1.empresaErrosSefaz = resp.data;
        } else {
          this.obs1.empresaErrosSefaz = [];
        }
      });
    } catch (ex) {
      toast.error("Erro ao carregar Empresas erros Sefaz, tente novamente mais tarde.", {});
    }
  }

  @action
  public async handleUpdatesModal(id: string, version: string): Promise<void> {

    this.obs1.result_ok = false;

    try {

      let data = {
        _id: id,
        version: version,
      };

      let resp = await api.post("/api/updates-modal", data);

      if (resp.data == "ok") {
        this.obs1.result_ok = true;
      }
    } catch (ex) {

      toast.error("Erro ao realizar Update Modal Alterações, tente novamente mais tarde.", {});

    }

  }

  private resetTimer = () => {
    clearTimeout(this.obs1.timer);
    this.obs1.timer = setTimeout(() => {
      window.location.assign("/");
    }, 7200000);
  };

  async notificacaoVisualizada() {
    try {
      let resp = await api.get("/api/notificacao/visualizada");

      if (resp.data.ok) {
        PerfilStore.obs.alteracaoPlanos = []
      }

    } catch (ex) {
      toast.error(`Erro ao Visualizar Notificação, tente novamente mais tarde.`, {});
    }
  }

  async handleGraphStats() {
    try {
      let resp = await api.get(`/api/dashboard-graph`)

      runInAction(() => {
        AppStore.obs.totalJaneiro = (resp.data.total_1 || 0)
        AppStore.obs.totalFevereiro = (resp.data.total_2 || 0)
        AppStore.obs.totalMarco = (resp.data.total_3 || 0)
        AppStore.obs.totalAbril = (resp.data.total_4 || 0)
        AppStore.obs.totalMaio = (resp.data.total_5 || 0)
        AppStore.obs.totalJunho = (resp.data.total_6 || 0)
        AppStore.obs.totalJulho = (resp.data.total_7 || 0)
        AppStore.obs.totalAgosto = (resp.data.total_8 || 0)
        AppStore.obs.totalSetembro = (resp.data.total_9 || 0)
        AppStore.obs.totalOutubro = (resp.data.total_10 || 0)
        AppStore.obs.totalNovembro = (resp.data.total_11 || 0)
        AppStore.obs.totalDezembro = (resp.data.total_12 || 0)

        AppStore.obs.totalErroJaneiro = (resp.data.total_erros_1 || 0)
        AppStore.obs.totalErroFevereiro = (resp.data.total_erros_2 || 0)
        AppStore.obs.totalErroMarco = (resp.data.total_erros_3 || 0)
        AppStore.obs.totalErroAbril = (resp.data.total_erros_4 || 0)
        AppStore.obs.totalErroMaio = (resp.data.total_erros_5 || 0)
        AppStore.obs.totalErroJunho = (resp.data.total_erros_6 || 0)
        AppStore.obs.totalErroJulho = (resp.data.total_erros_7 || 0)
        AppStore.obs.totalErroAgosto = (resp.data.total_erros_8 || 0)
        AppStore.obs.totalErroSetembro = (resp.data.total_erros_9 || 0)
        AppStore.obs.totalErroOutubro = (resp.data.total_erros_10 || 0)
        AppStore.obs.totalErroNovembro = (resp.data.total_erros_11 || 0)
        AppStore.obs.totalErroDezembro = (resp.data.total_erros_12 || 0)
      });
    } catch (ex) { }
  }

  async statsManifestacoes() {

    try {
      let resp = await api.get('/api/dashboard-stats');

      return resp.data

    } catch (ex) {
      return []
    }
  }

  async handleIndexReleases(page: number) {
    try {
      let params = {
        page: page,
        limit: 10
      }

      let resp = await api.post("/api/releases/index", params);

      this.obs1.releases = [];
      this.obs1.releases_length = 0;

      if (resp.data.itens.length > 0) {
        this.obs1.releases = resp.data.itens
        this.obs1.releases_length = resp.data.count;

      } else {}

    } catch (ex) {
      toast.error('Erro ao filtrar Logs, tente novamente mais tarde.', {});
    }
  }

  async handleDownloadSitfis(cnpj: string) {

    try {

      let data = {
        page: 1,
        limit: 1,
        cnpj: cnpj
      }

      let resp = await api.post("/api/sitfis/index", data);

      if (!(resp.data.itens.length == 0)) {

        const row = resp.data.itens[0];

        await SitfisStore.downloadArquivos(row.sitfis_id, cnpj);

      }

    } catch (ex) { }

  }

  constructor() {
    this.obs1.timer = null;
    this.resetTimer();
    this.setLocationFromPath(history.location.pathname);
    // this.setSelectedPeriod([moment().startOf("month").toDate(), moment().endOf("month").toDate()]);

    history.listen((location: any, action: any) => {
      this.setLocationFromPath(location.pathname);
    });

    document.onclick = this.resetTimer;
  }

  async checkStatus() {

    try {

      let resp = await api.get("/api/sefa/status");

      if (resp.status == 200) {

        if (resp.data.total_instaveis > resp.data.total_estaveis) {

          this.obs1.instavel = true
          return

        }

      }

    } catch (ex) { }

    this.obs1.instavel = false

  }

}

export const AppStore = new _AppStore();
